import { render, staticRenderFns } from "./DbGLTransactionList.vue?vue&type=template&id=48b59a54&"
import script from "./DbGLTransactionList.vue?vue&type=script&lang=js&"
export * from "./DbGLTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./DbGLTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports